import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { bookingUrl, contact, photos, rating } from '../data/site';
export function Hero() {
  return <section id="top" className="bg-cream" data-id="element-49" data-mp="ehtjpxlbn3oc">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 pb-12 pt-10 lg:grid-cols-12 lg:items-center lg:gap-12 lg:px-8 lg:pb-20 lg:pt-16" data-id="element-50" data-mp="9k0f38zo2hq6">
        <div className="lg:col-span-5" data-id="element-51" data-mp="4njrcfwdq5dm">
          <h1 className="font-serif text-5xl font-medium leading-[1.02] text-ink sm:text-6xl xl:text-7xl" data-id="element-52" data-mp="1297ahz3tqr77">
            Spa & soins esthétiques au cœur de Paris 16<sup className="text-[0.5em]" data-id="element-53" data-mp="xaxfboi3nqll">e</sup>
          </h1>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-muted" data-id="element-54" data-mp="sai4p4p7cx7b">
            Hydrafacial, massages signature, hammam : des rituels haut de gamme, réalisés sur-mesure dans un cadre
            luxueux et apaisant.
          </p>

          <div className="mt-8 flex flex-wrap gap-3" data-id="element-55" data-mp="3d2torapbqmf2">
            <a href={bookingUrl} className="whitespace-nowrap rounded-full bg-sage px-7 py-3.5 font-bold text-white transition-colors duration-150 hover:bg-sage-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage" data-id="element-56" data-mp="381xl8y8vx2a6">
              Réserver un soin
            </a>
            <a href="#soins" className="whitespace-nowrap rounded-full border border-ink/20 px-7 py-3.5 font-bold text-ink transition-colors duration-150 hover:border-ink" data-id="element-57" data-mp="39cfkx0rpn1u1">
              Voir la carte des soins
            </a>
          </div>

          <dl className="mt-10 flex flex-wrap gap-x-8 gap-y-3 border-t border-line pt-6 text-sm text-muted" data-id="element-58" data-mp="35a2fkdgvl5xs">
            <div className="flex items-center gap-2" data-id="element-59" data-mp="2qhqurk8mavyx">
              <StarIcon className="h-4 w-4 fill-ink text-ink" aria-hidden data-id="element-60" data-mp="2vi50uwqnrvub" />
              <dt className="sr-only" data-id="element-61" data-mp="2hjf8tvip4mct">Note</dt>
              <dd data-id="element-62" data-mp="2hjowhcg9qhfc">
                <span className="font-bold text-ink" data-id="element-63" data-mp="2hl9rt4aeq4e9">{rating.score}/5</span> · {rating.count} avis clients
              </dd>
            </div>
            <div className="flex items-center gap-2" data-id="element-64" data-mp="s2joo1a4k8lm">
              <MapPinIcon className="h-4 w-4 text-ink" aria-hidden data-id="element-65" data-mp="s44ghj521dfs" />
              <dt className="sr-only" data-id="element-66" data-mp="najgjljwi9dy">Adresse</dt>
              <dd data-id="element-67" data-mp="ic87ve5ce4xb">
                <a href={contact.mapsUrl} className="underline-offset-4 hover:text-ink hover:underline" data-id="element-68" data-mp="ibp0ush8d0y2">
                  {contact.address}, {contact.city}
                </a>
              </dd>
            </div>
          </dl>
        </div>

        <figure className="lg:col-span-7" data-id="element-69" data-mp="1b0du65c1o1z9">
          <img src={photos.reception} alt="L'accueil de l'institut : boiseries en acajou, fauteuil blanc et sol en marbre" className="aspect-[4/3] w-full rounded-sm object-cover lg:aspect-[16/11]" data-id="element-70" data-mp="1622hlmud7ddc" />
        </figure>
      </div>
    </section>;
}